// extracted by mini-css-extract-plugin
export default {"wrapper":"Hint_wrapper__9L12h","hint":"Hint_hint__dkrUg"};